import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

/**
 * 获取组织邀请学员配置信息
 * @returns {*}
 */
export const getInviteInfo = (config) => {
    return hMacAjax.get(baseURL + '/grt-student-service/open/student/v1/org-invite', {}, config);
};
/**
 * 承接类型-获取组织邀请学员配置信息
 * @returns {*}
 */
export const getCustomInviteInfo = (org_id, config) => {
    return hMacAjax.get(baseURL + '/grt-student-service/open/student/v1/org-invite/config/by-orgId', { org_id }, config);
};
/**
 * 验证身份信息
 * @returns {*}
 */
export const verifyInfo = (data, config) => {
    return hMacAjax.post(baseURL + '/grt-student-service/open/student/v1/org-invite/verify', data, config);
};

/**
 * 绑定账号
 * @returns {*}
 */
export const bindAccount = (data, config) => {
    return hMacAjax.post(baseURL + '/grt-student-service/open/student/v1/org-invite/bind', data, config);
};

/**
 * 完善信息
 * @returns {*}
 */
export const improveInfo = (data, config) => {
    return hMacAjax.post(baseURL + '/grt-student-service/open/student/v1/org-invite/improve', data, config);
};

//查询学院管理应用类型
export async function handleByTypeConfig(data, config) {
    return hMacAjax.get(`${baseURL}/apaas-system-service/config/v1/by-type`, data, config);
}

//查询当前学员所在的组织
export async function getOrgListReq(data, config) {
    return hMacAjax.get(`${baseURL}/grt-student-service/open/student/v1/org-invite/enabled/orgIds`, data, config);
}

// 组织码二期
// 校验组织码是否可用
export const checkInviteInfoReq = (data, config) => {
    return hMacAjax.get(baseURL + '/grt-student-service/open/student/v1/org-code-invite/check', data, config);
};

//查询当前学员所在的组织
export async function getInviteOrgListReq(data, config) {
    return hMacAjax.get(`${baseURL}/grt-student-service/open/student/v1/org-code-invite/select`, data, config);
}
